import React, { useEffect, useState } from 'react'
import { Box, Button, Card, Grid, Tab, Tabs, Typography } from "@mui/material";
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { useDispatch } from 'react-redux';
import Breadcrumbs from "../../../components/breadcrumbs";
import CreationDialog from '../../../components/dialog';
import CutoffLunchMenuTable from '../../../components/admin/portalDesign/cutoffLunchMenu';
import CutoffLunchMenuCreation from '../../../components/admin/portalDesign/cutoffLunchMenu/cutoffLunchMenuCreation';
import CutoffScheduleTable from '../../../components/admin/portalDesign/cutoffLunchMenu/cutoffScheduleTable';
import CutoffScheduleCreation from '../../../components/admin/portalDesign/cutoffLunchMenu/cutoffScheduleCreation';
import { getDropDownWatcher } from '../../../redux/actionCreators/admin/employeeManagement';
import { getMenuItemMasterWatcher } from '../../../redux/actionCreators/admin/menuItemMaster';
import { getMealDropdownWatcher, getMenuMasterWatcher } from '../../../redux/actionCreators/admin/menuMaster';

/*
  Two tabs:
    Today's Cutoffs - the cutoff rows themselves (one per day), added by hand or
                      by a schedule. This is what the app reads.
    Schedules       - daily / recurring templates that create those rows,
                      automatically every due day or when "Generate today" is pressed.
*/
const TAB_CUTOFFS = 0
const TAB_SCHEDULES = 1

const CutoffLunchMenu = () => {

    const dispatch = useDispatch();

    const [tab, setTab] = useState(TAB_CUTOFFS)
    const [open, setOpen] = useState(false)
    const [editRow, setEditRow] = useState(null)

    useEffect(() => {
        dispatch(getDropDownWatcher())
        dispatch(getMenuItemMasterWatcher({ ACTION: 'SELECT' }))
        dispatch(getMenuMasterWatcher({ ACTION: 'GridSELECT' }))
        dispatch(getMealDropdownWatcher())
    }, [dispatch])

    const handleAdd = () => {
        setEditRow(null)
        setOpen(true)
    }

    const handleEdit = (rowData) => {
        setEditRow(rowData)
        setOpen(true)
    }

    const handleClose = (value) => {
        setOpen(value)
        if (!value) setEditRow(null)
    }

    const schedules = tab === TAB_SCHEDULES

    return (
        <>
            <Box p='30px'>
                <Breadcrumbs content={["Portal Design", "Cutoff Lunch Menu"]} />
                <Box p='15px 0'>
                    <Typography variant='t24_700' > Cutoff Lunch Menu </Typography>
                </Box>

                <Card style={{ boxShadow: (theme) => `0px 12px 23px ${theme.palette.grey[200]}` }}>
                    <Grid container spacing={3} sx={{ padding: '30px', pb: '20px' }} >
                        <Grid item md={6} xs={12} sx={{ justifyContent: 'left' }}>
                            <Tabs value={tab} onChange={(e, v) => setTab(v)} aria-label='cutoff lunch tabs'>
                                <Tab label={<Typography variant='t16_500'>Today's Cutoffs</Typography>} />
                                <Tab label={<Typography variant='t16_500'>Schedules</Typography>} />
                            </Tabs>
                        </Grid>
                        <Grid item md={6} xs={12} sx={{ justifyContent: 'right', display: 'flex' }}>
                            <Button variant='contained' endIcon={<DoubleArrowIcon />} sx={{ width: '197px', height: '50px' }} onClick={handleAdd} >
                                <Typography variant='t16_500' >
                                    {schedules ? 'Add Schedule' : 'Add Cutoff'}
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            {schedules
                                ? <CutoffScheduleTable onEdit={handleEdit} />
                                : <CutoffLunchMenuTable onEdit={handleEdit} />}
                        </Grid>
                    </Grid>
                </Card>
            </Box>

            {open &&
                <CreationDialog open={open} setOpen={handleClose} >
                    {schedules
                        ? <CutoffScheduleCreation setOpen={handleClose} editData={editRow} />
                        : <CutoffLunchMenuCreation setOpen={handleClose} editData={editRow} />}
                </CreationDialog >
            }
        </>
    )
}

export default CutoffLunchMenu;
